import { createLazyComponent } from '@muse-web/router'

export const AsyncDownloadDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-download' */ './DownloadDialogContainer'),
    'DownloadDialogContainer',
)
